import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { PageBlockCtaTargetType } from './Enums'
/**
* Class ShowcasePageBlockCtaDto
*  Опциональная кнопка / ссылка.
*/
export class ShowcasePageBlockCtaDto extends ActiveModel {

/**
  * label
  * Текст кнопки / ссылки.
  */
  @ActiveField('')
  label: string = ''


  /**
  * targetType
  * словарь значений публикуется под именем `Domain.Entities.PageBlocks.PageBlockCtaTargetType`  *   * Тип цели перехода.  *   * - `Catalog` Каталог  * - `Category` Категория  * - `ProductCollection` Подборка  * - `ContentPage` CMS-страница  * - `ExternalUrl` Внешняя ссылка  *   */
  @ActiveField(PageBlockCtaTargetType.CATALOG)
  targetType: PageBlockCtaTargetType = PageBlockCtaTargetType.CATALOG


  /**
  * categoryId
  * Целевая категория; для Domain.Entities.PageBlocks.PageBlockCtaTargetType.Category.  */
  @ActiveField()
  categoryId?: null | number


  /**
  * productCollectionId
  * Целевая подборка; для Domain.Entities.PageBlocks.PageBlockCtaTargetType.ProductCollection.  */
  @ActiveField()
  productCollectionId?: null | number


/**
  * contentSlug
  * Slug CMS-страницы; для Domain.Entities.PageBlocks.PageBlockCtaTargetType.ContentPage.
  */
  @ActiveField()
  contentSlug?: null | string


/**
  * externalUrl
  * Внешний URL; для Domain.Entities.PageBlocks.PageBlockCtaTargetType.ExternalUrl.
  */
  @ActiveField()
  externalUrl?: null | string
}
